var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container-check", style: `paddingTop:${_vm.barHeight}px` },
    [
      _c("van-nav-bar", {
        staticClass: "van-bar",
        attrs: { title: "", "left-arrow": "" },
        on: { "click-left": _vm.closeWeb },
        scopedSlots: _vm._u([
          {
            key: "left",
            fn: function () {
              return [
                _c("img", {
                  staticClass: "left-nav",
                  attrs: {
                    src: require("@/assets/packageAssets/common/arrow05.png"),
                    alt: "",
                  },
                  on: { "click-left": _vm.closeWeb },
                }),
                _c("span", { staticClass: "tit-left" }, [
                  _vm._v(_vm._s(_vm.$t("lang.check.tit"))),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("div", { staticClass: "main" }, [
        _c("div", { staticClass: "check-state" }, [
          _c("img", {
            staticClass: "check_logo",
            attrs: { src: _vm.imgCheckResult, alt: "" },
          }),
          !_vm.flag
            ? _c("div", { staticClass: "text text-checking" }, [
                _c("div", [_vm._v(_vm._s(_vm.$t("lang.check.checking")))]),
                _c("div", { staticClass: "ball ball1" }),
                _c("div", { staticClass: "ball ball2" }),
                _c("div", { staticClass: "ball ball3" }),
              ])
            : _vm._e(),
          _vm.flag
            ? _c(
                "div",
                { staticClass: "text" },
                [
                  _vm.checkResult
                    ? [
                        _c("div", { staticClass: "text-success" }, [
                          _vm._v(_vm._s(_vm.$t("lang.check.checkPassed"))),
                        ]),
                        _c("div", { staticClass: "after" }, [
                          _vm._v(_vm._s(_vm.$t("lang.check.checkPassedTip"))),
                        ]),
                      ]
                    : [
                        _c("div", { staticClass: "text-failure" }, [
                          _vm._v(" " + _vm._s(_vm.$t("lang.wd.state1")) + " "),
                          _c("div", { staticClass: "after" }, [
                            _vm._v(_vm._s(_vm.$t("lang.check.disapprovedTip"))),
                          ]),
                        ]),
                      ],
                ],
                2
              )
            : _vm._e(),
        ]),
        _c("div", { staticClass: "left-times" }, [
          _vm._v(" " + _vm._s(_vm.$t("lang.check.times")) + ": "),
          _c("span", [_vm._v(_vm._s(_vm.remainCheckTimes))]),
        ]),
        _c(
          "ul",
          [
            _c("li", [
              _c("div", { staticClass: "requirements" }, [
                _vm._v(" " + _vm._s(_vm.$t("lang.check.requirements")) + " "),
                _c("div", { staticClass: "before" }, [
                  _vm._v(_vm._s(_vm.$t("lang.check.sevenDays"))),
                ]),
              ]),
              _c("div", [_vm._v(_vm._s(_vm.$t("lang.newInvite.k014")))]),
              _c("div", [_vm._v(_vm._s(_vm.$t("lang.check.status")))]),
            ]),
            _vm._l(_vm.conditions, function (item) {
              return _c("li", { key: item.id }, [
                _c("div", [_vm._v(_vm._s(item.condition))]),
                item.performance == ""
                  ? _c("div", [_vm._v("-")])
                  : _c("div", [_vm._v(_vm._s(item.performance || 0))]),
                _c("div", { staticClass: "state-icon" }, [
                  item.checkResult == 0
                    ? _c("img", {
                        staticClass: "checking_icon",
                        attrs: {
                          src: require("@/assets/packageAssets/views/P1_Girls/CheckPerformance/vava/checking_icon.png"),
                          alt: "",
                        },
                      })
                    : _vm._e(),
                  item.checkResult == 1
                    ? _c("img", {
                        attrs: {
                          src: require("@/assets/packageAssets/views/P1_Girls/CheckPerformance/vava/failure_icon.png"),
                          alt: "",
                        },
                      })
                    : _vm._e(),
                  item.checkResult == 2
                    ? _c("img", {
                        attrs: {
                          src: require("@/assets/packageAssets/views/P1_Girls/CheckPerformance/vava/success_icon.png"),
                          alt: "",
                        },
                      })
                    : _vm._e(),
                ]),
              ])
            }),
          ],
          2
        ),
      ]),
      _c("c-failure", {
        attrs: { showCheckFailureDia: _vm.showCheckFailureDia },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }